import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import makeStyles from "@material-ui/styles/makeStyles";
import {
    changeDrawerWidth, setDrawerProps,
    setDrawerState, toggleDrawer,
} from "../../app/app.slice";
import SidebarDrawer from "./SidebarDrawer";
import RenderComponents from "../JsonScreen/Screen/ScreenComponents/RenderComponents";
import {JsonScreenProvider} from '../../ContextComponents/JsonScreenContext'
import {uid} from "react-uid";
import clsx from "clsx";
import IconCustom from "../../Utils/IconCustom/IconCustom";

const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        overflow: 'auto'
    },
    treeViewRoot: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },
    dragger: {
        width: "2.5px",
        cursor: "ew-resize",
        padding: "4px 0 0",
        //borderTop: "1px solid #ddd",
        position: "absolute", top: 0, right: 0, bottom: 0,
        zIndex: 100
    }
}))
const SideBar = (props) => {
    const {component: {properties = {}} = {}} = props;
    const {isOpenDrawer} = useSelector(state => state.app);
    const currentUser = JSON.parse(sessionStorage.getItem("user")) || {};
    const dispatch = useDispatch();
    const {component: {children = [], styles: sourceStyles}, doActions, onChangeFields, screenName} = props;
    const classes = useStyles();
    const styles = sourceStyles ? sourceStyles[0] : {};
    useEffect(() => {
        dispatch(setDrawerProps(properties))
        return () => {
            dispatch(changeDrawerWidth(0));
            dispatch(setDrawerProps({}))
        }
    }, [])


    useEffect(() => {
        const isUserMenu = currentUser.user && currentUser.user.menu;
        dispatch(changeDrawerWidth(isUserMenu ? properties.sidebarOpenWidth ? properties.sidebarOpenWidth : 290 : 0));
    }, [JSON.stringify(currentUser)]);

    function onKeyDownMenuContainer(e) {
        if (e.altKey && e.key === 'd') {
            const searchBar = document.getElementById('searchBar');
            searchBar && searchBar.focus();
            e.preventDefault();
        }
    }

//drawer width change controller
    const handleMouseDown = e => {
        e.preventDefault();
        document.addEventListener("mouseup", handleMouseUp, true);
        document.addEventListener("mousemove", handleMouseMove, true);
    };
    const handleMouseUp = () => {
        document.removeEventListener("mouseup", handleMouseUp, true);
        document.removeEventListener("mousemove", handleMouseMove, true);
    };
    const handleMouseMove = (e) => {
        const minDrawerWidth = 150;
        const maxDrawerWidth = document.body.clientWidth;
        const newWidth = e.clientX - document.body.offsetLeft;
        if (newWidth < 100) {
            dispatch(setDrawerState(false));
            dispatch(changeDrawerWidth(280));
        }
        if (newWidth > minDrawerWidth && newWidth < maxDrawerWidth) {
            dispatch(changeDrawerWidth(newWidth))
        }
    };

    return (
        <div onKeyDown={onKeyDownMenuContainer}>
            <SidebarDrawer
                styles={styles}
                properties={properties}
            >
                <div
                    onMouseDown={e => handleMouseDown(e)}
                    className={clsx(classes.dragger, 'sb-sidebar-dragger')}
                />
                {properties.toggleButton && (
                    <div style={{
                        position: 'absolute',
                        right: -5,
                        zIndex: 9999,
                        top: properties.paddingTop,
                        background: "white",
                        display: 'flex',
                        borderRadius: 6,
                        cursor: 'pointer'
                    }}>
                        <IconCustom iconType={"symbols-outlined"} onClick={() => dispatch(toggleDrawer())}>
                            {isOpenDrawer ? properties.openedIcon : properties.closedIcon}
                        </IconCustom>
                    </div>
                )}
                <JsonScreenProvider value={{
                    doActions: (action, context, event) => doActions(action, context, event, screenName),
                    setValue: (value, path, trackChange) => onChangeFields(value, `param.${screenName}.${path}`, trackChange),
                    screenName
                }}>
                    <div style={{
                        // border: '1px solid',
                        width: '100%', height: '100%'
                    }}
                         className={"sb-sidebar"}
                    >
                    <div style={{width: '100%', height: '98%'}} className={"sb-sidebar-container"}>
                            {children.map(component => {
                                return (
                                    <RenderComponents
                                        key={uid(component)}
                                        element={component}
                                        isTableCell={false}
                                        actionsContext={{doc: {isOpenDrawer, closedCompact: properties.closedCompact}}}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </JsonScreenProvider>
            </SidebarDrawer>
        </div>
    )
}
export default SideBar;